import ImgEventManagement from "../assets/event-management.jpg";
import ImgTentServicing from "../assets/tent-servicing.jpg";
import ImgSeating from "../assets/seating.jpg";
import ImgCatering from "../assets/catering.jpg";
import ImgVIP from "../assets/vip-toilet.jpg";

function Services() {
  return (
    <section className="services-section">
      <div className="container">
        <div className="row shadow">
          <div className="col-12 pb-5">
            <div className="d-flex flex-column align-items-center content-heading text-secondary text-center pt-5">
              Providing Ultimate Service
            </div>
            <div className="content-subheading text-secondary text-center pb-4">
              Our range of equipments for hire
            </div>
          </div>

          <div className="col-12 col-md-6 d-flex justify-content-center">
            <img className="img img-fluid" src={ImgEventManagement} />
          </div>
          <div className="col-12 col-md-6">
            <div className="content-heading text-secondary pt-5">
              Events Management
            </div>
            <p className="p-3">
              We render our service for any kind of event, i.e. Funerals,
              Unveilings Weddings, Parties, Anniversaries etc.
            </p>
          </div>
          <div className="col-12 col-md-6">
            <div className="content-heading text-secondary pt-5">
              Tents Services
            </div>
            <div className="p-3">
              Our tent servicing includes:-
              <ul className="ml-5 py-3">
                <li>Poles for hire</li>
                <li>Frame Tents</li>
                <li>Marquees</li>
                <li>Stretch Tents</li>
              </ul>
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center pb-3">
            <img className="img img-fluid" src={ImgTentServicing} />
          </div>

          <div className="col-12 col-md-6 d-flex justify-content-center pt-3">
            <img className="img img-fluid" src={ImgSeating} />
          </div>
          <div className="col-12 col-md-6">
            <div className="content-heading text-secondary pt-5">
              Seating Equipments
            </div>
            <div className="p-3">
              Our Seating equipments includes:-
              <ul className="ml-5 py-3">
                <li>Chairs for hire</li>
                <li>Tables for hire</li>
                <li>Couches</li>
                <li>Bar Chairs</li>
                <li>Bar Tables</li>
              </ul>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="content-heading text-secondary pt-5">
              Catering Equipments
            </div>
            <div className="p-3">
              Our Catering equipments includes:-
              <ul className="ml-5 py-3">
                <li>Gas Stoves for hire</li>
                <li>Gas Bottle for hire</li>
                <li>Food Catering</li>
                <li>Decoration</li>
              </ul>
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center pb-3">
            <img className="img img-fluid" src={ImgCatering} />
          </div>

          <div className="col-12 col-md-6 d-flex justify-content-center pt-3">
            <img className="img img-fluid" src={ImgVIP} />
          </div>
          <div className="col-12 col-md-6">
            <div className="content-heading text-secondary pt-5">
              VIP Equipments
            </div>
            <div className="p-3">
              Our Catering equipments includes:-
              <ul className="ml-5 py-3">
                <li>Red Carpet for hire</li>
                <li>Mobile Freezer for hire</li>
                <li>Mobile Coolers</li>
                <li>Mobile Toilets</li>
                <li>PA System</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
